<template>
  <div class="w-[9rem]" ref="dropdownWhyusContent">
    <a href="https://www.jainuniversity.ac.in/" @click="
      handleLinkClick(
        'Jain University',
        'Why Us',
        'https://www.jainuniversity.ac.in/'
      )
      ">
      <div class="flex justify-between items-center cursor-pointer p-3 hover:bg-[#EFEFEF]">
        <div class="text-xs">JAIN University</div>
        <!-- <div><img src="@/assets/nav/right-arrow.webp" class="w-[10px] h-[16px] object-contain" alt="right arrow"></div> -->
      </div>
    </a>
    <a href="/technology/" @click="
      handleLinkClick(
        'Technology',
        'Why Us',
        'https://onlinejain.com/technology'
      )
      ">
      <div class="flex justify-between items-center cursor-pointer p-3 hover:bg-[#EFEFEF]">
        <div class="text-xs">Technology</div>
        <!-- <div><img src="@/assets/nav/right-arrow.webp" class="w-[10px] h-[16px] object-contain" alt="right arrow"></div> -->
      </div>
    </a>
    <a href="/testimonial/" @click="
      handleLinkClick(
        'Success Stories',
        'Why Us',
        'https://onlinejain.com/testimonial'
      )
      ">
      <div class="flex justify-between items-center cursor-pointer p-3 hover:bg-[#EFEFEF]">
        <div class="text-xs">Success Stories</div>
        <div>
          <!-- <img src="@/assets/nav/right-arrow.webp" class="w-[10px] h-[16px] object-contain" alt="right arrow"> -->
        </div>
      </div>
    </a>

    <a href="/academics/" @click="
      handleLinkClick(
        'Our Teaching',
        'Why Us',
        'https://onlinejain.com/academics'
      )
      ">
      <div class="flex justify-between items-center cursor-pointer p-3 hover:bg-[#EFEFEF]">
        <div class="text-xs">Our Teaching</div>
        <div>
          <!-- <img src="@/assets/nav/right-arrow.webp" class="w-[10px] h-[16px] object-contain" alt="right arrow"> -->
        </div>
      </div>
    </a>

    <a href="/life-at-jo/" title="Life At JO" @click="
      handleLinkClick(
        'Life At JO',
        'Why Us',
        'https://onlinejain.com/life-at-jo'
      )
      ">
      <div class="flex justify-between items-center cursor-pointer p-3 hover:bg-[#EFEFEF]">
        <div class="text-xs">Life At JO</div>
        <div>
          <!-- <img src="@/assets/nav/right-arrow.webp" class="w-[10px] h-[16px] object-contain" alt="right arrow"> -->
        </div>
      </div>
    </a>

    <a href="/careers/" @click="
      handleLinkClick(
        'Career Growth',
        'Why Us',
        'https://onlinejain.com/careers/'
      )
      ">
      <div class="flex justify-between items-center cursor-pointer p-3 hover:bg-[#EFEFEF]">
        <div class="text-xs">Career Growth</div>
        <div>
          <!-- <img src="@/assets/nav/right-arrow.webp" class="w-[10px] h-[16px] object-contain" alt="right arrow"> -->
        </div>
      </div>
    </a>

    <a href="/blogs/" @click="
      handleLinkClick(
        'Blogs',
        'Why US',
        'https://onlinejain.com/blogs/'
      )
      ">
      <div class="flex justify-between items-center cursor-pointer p-3 hover:bg-[#EFEFEF]">
        <div class="text-xs">Blogs</div>
        <div>
          <!-- <img src="@/assets/nav/right-arrow.webp" class="w-[10px] h-[16px] object-contain" alt="right arrow"> -->
        </div>
      </div>
    </a>

    <a href="/micro-credentials-online-courses/" @click="
      handleLinkClick(
        'Micro Credential',
        'Why Us',
        'https://onlinejain.com/micro-credentials-online-courses/'
      )
      ">
      <div class="flex justify-between items-center cursor-pointer p-3 hover:bg-[#EFEFEF]">
        <div class="text-xs">Micro Credential</div>
        <div>
          <!-- <img src="@/assets/nav/right-arrow.webp" class="w-[10px] h-[16px] object-contain" alt="right arrow"> -->
        </div>
      </div>
    </a>
  </div>
</template>


<script>
export default {

  methods: {
    handleLinkClick(item) {
      // Emit the item click event with its data
      this.$emit("item-clicked", item);
    },
  },
};
</script>